import { WIX_EVENTS } from '@wix/app-definition-ids';

import * as helpIds from '#packages/helpIds';
import * as tpa from '#packages/tpa';

import type { MapDispatchToPropsFunction, MapStateToProps } from 'types/redux';
import type {
  EventsWelcomeDispatchProps,
  EventsWelcomeOwnProps,
  EventsWelcomeStateProps,
} from './types';
import {
  EditorType,
  InstallationOriginType,
  InstallInitiator,
} from '@wix/platform-editor-sdk';

export const mapStateToProps: MapStateToProps<
  EventsWelcomeStateProps,
  EventsWelcomeOwnProps
> = ({ editorAPI }) => ({
  welcomeSectionTemplate: editorAPI.addPanelInfra.welcomeSection,
});

const getEditorAPI = (
  dispatch: AnyFixMe,
  getState: AnyFixMe,
  { editorAPI }: AnyFixMe,
) => editorAPI;

export const mapDispatchToProps: MapDispatchToPropsFunction<
  EventsWelcomeDispatchProps,
  EventsWelcomeOwnProps
> = (dispatch) => {
  const editorAPI = dispatch(getEditorAPI);

  return {
    installEventsApp: () =>
      tpa.superApps.addApp(WIX_EVENTS, {
        biOrigin: tpa.constants.BI.type.ADD_APP_APP_BUTTON,
        platformOrigin: {
          type: EditorType.Classic,
          initiator: InstallInitiator.Editor,
          info: {
            type: InstallationOriginType.AddPanel,
          },
        },
        callback: (data: AnyFixMe) => {
          const pageId = data?.page?.id;

          if (pageId) {
            editorAPI.pages.navigateTo(pageId, () => {
              const sectionPointer =
                tpa.superApps.getSectionRefByPageId(pageId);
              editorAPI.selection.selectComponentByCompRef(sectionPointer);
            });
          }
        },
      }),
    openHelpCenter: () =>
      editorAPI.panelManager.openHelpCenter(helpIds.ADD_PANEL.EVENTS),
    openAppMarket() {
      const appMarketPanelProps = {
        urlParams: {
          slug: WIX_EVENTS,
        },
      };

      tpa.appMarketTabService.openAppMarketTab(
        appMarketPanelProps,
        editorAPI.panelManager.openPanel,
      );
    },
  };
};
